import type { Payment } from "@/models/payment";

export const getPayment = async (id: string): Promise<Payment> => {
  const url = `/api/onboarding/payment/${id}`;
  try {
    const resp = await fetch(url);
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getPayment exception: ${error}`);
    throw error;
  }
};

export const initPayment = async (
  paymentId: string,
): Promise<{ id: string }> => {
  const url = `/api/onboarding/init-payment/${paymentId}`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(initPayment),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getPayment exception: ${error}`);
    throw error;
  }
};
